import React, { useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext.jsx'
import { EMOJI_SETS } from '../config/emojiSets.js'

export function useEmoji() {
  const ctx = useContext(ThemeContext)
  const emojiSet = ctx?.theme?.emojiSet || 'default'
  const set = EMOJI_SETS[emojiSet] || EMOJI_SETS.default

  function getEmoji(key) {
    const val = set[key]
    if (val) return val
    return EMOJI_SETS.default[key] ?? key
  }

  function Emoji({ name, size = 20 }) {
    const val = getEmoji(name)
    if (typeof val === 'string' && val.startsWith('/')) {
      return (
        <img
          src={val}
          alt=""
          style={{ width: size, height: size, objectFit: 'contain', display: 'block' }}
        />
      )
    }
    return <span style={{ fontSize: size * 0.8 }}>{val}</span>
  }

  return { getEmoji, Emoji }
}
